export const smallName = (name) => {
  const parts = name.split(' ');
  return parts.map((part) => part.substr(0, 1)).join('');
}
